import React from 'react';

import { DetailRowError } from '../detail-row/DetailRowError';

export const TaxImpactEstimateError: React.FC = () => {
  return <DetailRowError data-testid="tax-impact-estimate">Est. tax impact</DetailRowError>;
};
